// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".terms {\n  color: #d0dcdf;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.terms:hover {\n  color: #00daff;\n  text-decoration: none;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
